import { c as _c } from "react/compiler-runtime";
import { passkeyClient } from "@better-auth/passkey/client";
import { createAuthClient } from "better-auth/react";
import { useMemo } from "react";
import { useAppConfig } from "./config";
export function useAuthClient() {
  const $ = _c(2);
  const config = useAppConfig();
  const t0 = config.apiUrl + "/auth";
  let t1;
  if ($[0] !== t0) {
    t1 = createAuthClient({
      baseURL: t0,
      plugins: [passkeyClient()]
    });
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}